// extracted by mini-css-extract-plugin
export default {"availableBalance":"iWpE5","availableBalance__text":"WrN_H","availableBalance__textWrapper":"J4S_P","availableBalance__amount":"Fkof_","availableBalance__currency":"qchCQ"};